export const validateSurveyFormUrl = (formUrl: string, formId: string): boolean => {
  return formUrl.endsWith(formId)
}

export const cleanTypeformUrl = (url: string): string => {
  if (!url) return url
  const subPattern = /#sub=.+$/
  return url.replace(subPattern, '')
}
